import moment from 'moment'

const decode_auth_token = () => {
    try {
        let token = window.localStorage.getItem(app.store.state.rms_ui.auth.auth.suffix + 'token');
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const data = JSON.parse(window.atob(base64));
        let user = {
            application_id: data.a,
            id: data.u,
            campaigns: [],
            expTimestamp: data.exp,
            expDate: moment.unix(data.exp).format("YYYY/MM/DD HH:mm:ss"),
            lts: data.lts,
            app_version: data.appv
        }
        let campaign_index = 0;
        let aux_c = 0;
        let module_permissions = decode_module_permisisons(data.p);

        for (let c of data.c) {
            user.campaigns[campaign_index] = {
                id: aux_c + c,
                primary: data.uc == campaign_index ? true : false,
                owner: data.oc.includes(campaign_index) ? true : false,
                permissions: [],
            };
            for (let cp of data.cp[campaign_index]) {
                user.campaigns[campaign_index].permissions.push(module_permissions[cp]);
            }
            aux_c = aux_c + c;
            campaign_index += 1;
        }
        return (user);
    } catch (error) {
        return (error);
    }
}

const decode_module_permisisons = (str) => {
    let module_permissions = [];
    let arr = str.split("|");
    for (let p of arr) {
        let aux = p.split(",");
        for (let i = 1; i < aux.length; i++) {
            module_permissions.push(`${aux[0]}.${aux[i]}`);
        }
    }
    return (module_permissions);
}

export default decode_auth_token;
